import { createFileRoute } from '@tanstack/react-router';

import { Imprint } from '@/components/content/Imprint';

export const Route = createFileRoute('/_map/_sidebar/imprint')({
  beforeLoad: ({ search }) => {
    const { resultIndex, ...rest } = search as { resultIndex?: number } & Record<string, unknown>;

    return { search: rest };
  },
  component: Imprint,
});
